import { motion, useSpring, useTransform } from "framer-motion";
import { EASE } from "../../lib/api";

export const HeroFrame = ({ mx, my, scrollYProgress }) => {
  const rotateY = useSpring(useTransform(mx, [-0.5, 0.5], [-9, 9]), { stiffness: 110, damping: 18 });
  const rotateX = useSpring(useTransform(my, [-0.5, 0.5], [7, -7]), { stiffness: 110, damping: 18 });
  const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "16%"]);

  return (
    <div className="relative pb-16 lg:col-span-5 lg:pt-10" style={{ perspective: 1200 }}>
      <motion.div style={{ rotateX, rotateY, transformStyle: "preserve-3d" }} className="relative">
        <motion.div
          initial={{ clipPath: "inset(100% 0% 0% 0%)" }}
          animate={{ clipPath: "inset(0% 0% 0% 0%)" }}
          transition={{ duration: 1.4, ease: EASE, delay: 0.5 }}
          className="relative"
        >
          <div className="clip-notch relative aspect-[4/5] overflow-hidden bg-[var(--ink-2)] sm:aspect-[5/4] lg:aspect-[4/5]" data-testid="hero-image-frame">
            <motion.img src="/img/hero.jpg" alt="Warehouse team at work" style={{ y: imgY, scale: 1.18 }}
              className="h-full w-full object-cover grayscale-[35%] contrast-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-[rgba(14,15,12,0.85)] via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
              <p className="overline text-[var(--bone)]">Fig. 01 — On the floor</p>
              <p className="font-display text-6xl font-black leading-none text-[var(--signal)]">08</p>
            </div>
          </div>
        </motion.div>
        <motion.div style={{ translateZ: 60 }} initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: EASE, delay: 1.3 }}
          className="absolute -left-4 top-8 border border-white/15 bg-[rgba(14,15,12,0.7)] px-4 py-3 backdrop-blur-lg md:-left-10">
          <p className="overline text-[var(--signal)]">8 services</p>
          <p className="mt-1 font-display text-2xl font-extrabold uppercase">One contract</p>
        </motion.div>
      </motion.div>
    </div>
  );
};
